import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
export var SetSubscriptionErrorCodeV1;
(function(SetSubscriptionErrorCodeV1) {
    SetSubscriptionErrorCodeV1[SetSubscriptionErrorCodeV1["InvalidBillingOptionId"] = 15000] = "InvalidBillingOptionId";
    SetSubscriptionErrorCodeV1[SetSubscriptionErrorCodeV1["SubscriptionNotAvailableForMember"] = 15001] = "SubscriptionNotAvailableForMember";
    SetSubscriptionErrorCodeV1[SetSubscriptionErrorCodeV1["CurrentSubscriptionMinimumRequiredPeriodNotMet"] = 15002] = "CurrentSubscriptionMinimumRequiredPeriodNotMet";
    SetSubscriptionErrorCodeV1[SetSubscriptionErrorCodeV1["CurrentSubscriptionOnHold"] = 15003] = "CurrentSubscriptionOnHold";
    SetSubscriptionErrorCodeV1[SetSubscriptionErrorCodeV1["CurrentSubscriptionFrozen"] = 15004] = "CurrentSubscriptionFrozen";
})(SetSubscriptionErrorCodeV1 || (SetSubscriptionErrorCodeV1 = {}));
export class SetSubscriptionErrorV1 extends Error {
    constructor(errorCode){
        const error = `Failed to set subscription item. API error code ${errorCode}: ${SetSubscriptionErrorCodeV1[errorCode]}`;
        super(error);
        this.errorCode = errorCode;
    }
}
export async function getSetSubscriptionErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(SetSubscriptionErrorCodeV1).includes(errorCode) ? new SetSubscriptionErrorV1(errorCode) : error;
}

//# sourceMappingURL=set-subscription-error.js.map